import { BasePlugin } from '@easepick/base-plugin';
import {HDate} from /* webpackChunkName: "levcharity-hebcal" */ '@hebcal/core';
import { __ } from '@wordpress/i18n';
import { Helper } from '../Helper.js';
import { DateTime } from '@easepick/datetime';

class JewishCalendarPlugin extends BasePlugin {

	binds = {
		onView: this.onView.bind(this),
		onSelect: this.onSelect.bind(this),
		getDate: this.getDate.bind(this),
	}

	getMonthNames() {
		// Return an array containing the names of all 13 Jewish months
		return [
			__("Tishri", 'levcharity-jewish-calendar'),
			__("Cheshvan", 'levcharity-jewish-calendar'),
			__("Kislev", 'levcharity-jewish-calendar'),
			__("Tevet", 'levcharity-jewish-calendar'),
			__("Shevat", 'levcharity-jewish-calendar'),
			__("Adar", 'levcharity-jewish-calendar'),
			__("Nisan", 'levcharity-jewish-calendar'),
			__("Iyar", 'levcharity-jewish-calendar'),
			__("Sivan", 'levcharity-jewish-calendar'),
			__("Tammuz", 'levcharity-jewish-calendar'),
			__("Av", 'levcharity-jewish-calendar'),
			__("Elul", 'levcharity-jewish-calendar'),
			__("AdarI", 'levcharity-jewish-calendar'),
			__("AdarII", 'levcharity-jewish-calendar'),
		];
	}

	getWeekDayNames() {
		return [
			{
				short: __("Sun", 'levcharity-jewish-calendar'),
				full: __("Sunday", 'levcharity-jewish-calendar'),
				shortest: __("S", 'levcharity-jewish-calendar')
			},
			{
				short: __("Mon", 'levcharity-jewish-calendar'),
				full: __("Monday", 'levcharity-jewish-calendar'),
				shortest: __("M", 'levcharity-jewish-calendar')
			},
			{
				short: __("Tue", 'levcharity-jewish-calendar'),
				full: __("Tuesday", 'levcharity-jewish-calendar'),
				shortest: __("T", 'levcharity-jewish-calendar')
			},
			{
				short: __("Wed", 'levcharity-jewish-calendar'),
				full: __("Wednesday", 'levcharity-jewish-calendar'),
				shortest: __("W", 'levcharity-jewish-calendar')
			},
			{
				short: __("Thu", 'levcharity-jewish-calendar'),
				full: __("Thursday", 'levcharity-jewish-calendar'),
				shortest: __("T", 'levcharity-jewish-calendar')
			},
			{
				short: __("Fri", 'levcharity-jewish-calendar'),
				full: __("Friday", 'levcharity-jewish-calendar'),
				shortest: __("F", 'levcharity-jewish-calendar')
			},
			{
				short: __("Sat", 'levcharity-jewish-calendar'),
				full: __("Saturday", 'levcharity-jewish-calendar'),
				shortest: __("S", 'levcharity-jewish-calendar')
			},
		];
	}

	getName() {
		return 'JewishCalendarPlugin';
	}

	onAttach() {
		this.picker.on('view', this.binds.onView);
		this.picker.on('select', this.binds.onSelect);

		Object.defineProperties(this.picker, {
			getDate: {
				configurable: true,
				value: this.binds.getDate,
			},
		})

		const stylesheet = document.createElement('style');
		stylesheet.innerText = `
            .hebrew-date {
                display:flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
            }

            .hebrew-date .hebrew-month, .hebrew-date .hebrew-year {
                font-size: 0.65em;
            }
        `.replace(/\s\s+/g, '');
		this.picker.ui.shadowRoot.appendChild(stylesheet);
		this.stylesheet = stylesheet;
	}

	getDate() {
		let isLevFormat = this.picker.options?.isLevFormat || false;
		const value = this.picker.options.calendars;
		if (value) {
			const parsedDate = Date.parse(value);
			let format = this.picker.options.format;
			this.picker.options.element.value = this.picker.options.element.getAttribute('value');
			setTimeout(() => {
				delete this.picker.getDate;
			}, 1)
			return new DateTime(parsedDate, format);
		}
		return this.picker.options.date || null;
	}

	// getDate() {
	// 	let isLevFormat = this.picker.options?.isLevFormat || false;
	// 	const value = this.picker.options.date;
	// 	if (value) {
	// 		const parsedDate = new HDate().greg(value)
	// 		let format = this.picker.options.format;
	//
	// 		if (isLevFormat){
	// 			const replacements = {
	// 				'd': 'DD',
	// 				'D': 'DDD',
	// 				'j': 'D',
	// 				'l': 'DDDD',
	// 				'F': 'MMMM',
	// 				'm': 'MM',
	// 				'M': 'MMM',
	// 				'n': 'M',
	// 				'Y': 'YYYY',
	// 				'y': 'YY',
	// 			}
	//
	// 			format = format.replace(/(d|D|j|l|F|m|M|n|Y|y)(?!.*\1)/g, function (match) {
	// 				return replacements[match];
	// 			});
	// 			this.picker.options.element.value = this.picker.options.element.getAttribute('value');
	// 		} else {
	// 			this.picker.options.element.value = this.formatDateEP(this.picker.options.format, parsedDate / 1000);
	// 		}
	//
	// 		setTimeout(() => {
	// 			delete this.picker.getDate;
	// 		}, 1)
	// 		return new DateTime(parsedDate, format);
	// 	}
	// 	return this.picker.options.date || null;
	// }

	onView(event) {
		const { view, date } = event.detail;

		const daysGrid = this.picker.ui.container.querySelector('.days-grid');

		if (!daysGrid || daysGrid.classList.contains('hebrew-calendar')) return;

		// Modify day names
		const dayNames = this.picker.ui.container.querySelectorAll('.daynames-row .dayname');
		if (dayNames.length) {
			const weekDayNames = this.getWeekDayNames();
			dayNames.forEach((day, index) => {
				const weekDayName = weekDayNames[index];
				day.title = weekDayName.full;
				day.textContent = weekDayName.short;
			});
		}

		// Modify calendar days
		const days = this.picker.ui.container.querySelectorAll('.days-grid > *');
		days.forEach((dayElement, index) => {
			if (dayElement.matches('.offset')) return;

			const dateStr = dayElement.getAttribute('data-time');
			const date = new Date(+dateStr);
			const hebrewDate = new HDate(date);

			dayElement.classList.add('hebrew-date');

			dayElement.innerHTML = `<span class="hebrew-day">${hebrewDate.getDate()}</span><span class="hebrew-month">${hebrewDate.getMonthName()}</span><span class="hebrew-year">${hebrewDate.getFullYear()}</span>`;

		});
		daysGrid.classList.add('hebrew-calendar');
	}
	onSelect(event) {
		const { date } = event.detail;

		let isLevFormat = this.picker.options?.isLevFormat || false;

		let formattedDate = '';

		const format = this.picker.options.format;

		if (isLevFormat) {
			formattedDate = this.formatDate(format, date.getTime() / 1000);
		} else {
			formattedDate = this.formatDateEP(format, date.getTime() / 1000);
		}

		this.picker.options.element.value = formattedDate;

		const evt = new Event("change", { bubbles: true });
		this.picker.options.element.dispatchEvent(evt);
	}

	formatDate(format, timestamp = null) {
		let date;
		if (timestamp) {
			date = new Date(timestamp * 1000);
		} else {
			date = new Date();
		}

		if (!format) {
			return date.getTime();
		}

		const hebrewDate = new HDate(date);

		const replacements = {
			'd': ('0' + hebrewDate.getDate()).slice(-2),
			'D': this.getWeekDayNames()[hebrewDate.getDay()].short,
			'j': hebrewDate.getDate(),
			'l': this.getWeekDayNames()[hebrewDate.getDay()].full,
			'N': hebrewDate.getDay() === 0 ? 7 : hebrewDate.getDay(),
			'w': hebrewDate.getDay(),
			'F': hebrewDate.getMonthName(),
			'm': ('0' + (hebrewDate.getMonth() + 1)).slice(-2),
			'M': hebrewDate.getMonthName().substring(0, 3),
			'n': hebrewDate.getMonth() + 1,
			'Y': hebrewDate.getFullYear(),
			'y': ('' + hebrewDate.getFullYear()).slice(2),
		};

		return format.replace(/(d|D|j|l|N|w|F|m|M|n|Y|y)(?!.*\1)/g, function (match) {
			return replacements[match];
		});
	}

	formatDateEP(format, timestamp = null) {
		let date;
		if (timestamp) {
			date = new Date(timestamp * 1000);
		} else {
			date = new Date();
		}

		if (!format) {
			return date.getTime();
		}

		const hebrewDate = new HDate(date);

		const replacements = {
			'D': date.getDate(),
			'DD': ('0' + hebrewDate.getDate()).slice(-2),
			'DDD': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][date.getDay()],
			'DDDD': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][date.getDay()],
			'M': hebrewDate.getMonth(),
			'MM': ('0' + hebrewDate.getMonth()).slice(-2),
			'MMM': hebrewDate.getMonthName().slice(0, 3),
			'MMMM': hebrewDate.getMonthName(),
			'YY': ('' + hebrewDate.getFullYear()).slice(-2),
			'YYYY': hebrewDate.getFullYear(),
			'H': date.getHours(),
			'HH': ('0' + date.getHours()).slice(-2),
			'm': date.getMinutes(),
			'mm': ('0' + date.getMinutes()).slice(-2),
			's': date.getSeconds(),
			'ss': ('0' + date.getSeconds()).slice(-2),
		};
		return format.replace(/(D|DD|M|MM|MMM|MMMM|YY|YYYY|H|HH|m|mm|s|ss)(?!.*\1)/g, function (match) {
			return replacements[match];
		});
	}






}

class DatepickerPosition extends BasePlugin {
	getName() {
		return 'DatepickerPosition';
	}
	onAttach() {
		const stylesheet = document.createElement('style');
		const pickerPosition = this.picker.options?.datepickerPosition || 'left';
		if(pickerPosition === 'left') {
			stylesheet.innerText = `
				.container {
					right: unset!important;
					left: 0px;
				}
			`.replace(/\s\s+/g, '');
			this.picker.ui.shadowRoot.appendChild(stylesheet);
			this.stylesheet = stylesheet;
		}
	}
}

class LevcharityFormatter extends BasePlugin {
	binds = {
		onSelect: this.onSelect.bind(this),
		getDate: this.getDate.bind(this),
		onView: this.onView.bind(this)
	}

	getWeekDayNames() {
		return [
			{ short: __("Sun", 'levcharity-jewish-calendar'), full: __("Sunday", 'levcharity-jewish-calendar'), shortest: __("S", 'levcharity-jewish-calendar') },
			{ short: __("Mon", 'levcharity-jewish-calendar'), full: __("Monday", 'levcharity-jewish-calendar'), shortest: __("M", 'levcharity-jewish-calendar') },
			{ short: __("Tue", 'levcharity-jewish-calendar'), full: __("Tuesday", 'levcharity-jewish-calendar'), shortest: __("T", 'levcharity-jewish-calendar') },
			{ short: __("Wed", 'levcharity-jewish-calendar'), full: __("Wednesday", 'levcharity-jewish-calendar'), shortest: __("W", 'levcharity-jewish-calendar') },
			{ short: __("Thu", 'levcharity-jewish-calendar'), full: __("Thursday", 'levcharity-jewish-calendar'), shortest: __("T", 'levcharity-jewish-calendar') },
			{ short: __("Fri", 'levcharity-jewish-calendar'), full: __("Friday", 'levcharity-jewish-calendar'), shortest: __("F", 'levcharity-jewish-calendar') },
			{ short: __("Sat", 'levcharity-jewish-calendar'), full: __("Saturday", 'levcharity-jewish-calendar'), shortest: __("S", 'levcharity-jewish-calendar') }
		];
	}

	getName() {
		return 'LevcharityFormatter';
	}
	onAttach() {
		this.picker.on('select', this.binds.onSelect);
		this.picker.on('view', this.binds.onView);

		Object.defineProperties(this.picker, {
			getDate: {
				configurable: true,
				value: this.getDate.bind(this),
			},
		});

		const stylesheet = document.createElement('style');
		stylesheet.innerText = `
			.container {
				left: unset!important;
				right: 0;
			}
        `.replace(/\s\s+/g, '');
		this.picker.ui.shadowRoot.appendChild(stylesheet);
		this.stylesheet = stylesheet;
	}

	onView(event) {
		const { view, date } = event.detail;
		const dayNames = this.picker.ui.container.querySelectorAll('.daynames-row .dayname');
		if (dayNames.length) {
			const weekDayNames = this.getWeekDayNames();
			dayNames.forEach((day, index) => {
				const weekDayName = weekDayNames[index];
				if (weekDayName) {
					day.title = weekDayName.full;
					day.textContent = weekDayName.short;
				}
			});
		}
	}
	onSelect(event) {
		const { date } = event.detail;
		const timestamp = date.getTime();
		const format = this.picker.options.format;
		const newDateValue = Helper.date(format, timestamp / 1000);
		this.picker.options.element.value = newDateValue;
		this.picker.options.element.setAttribute('value', newDateValue);

		const evt = new Event("change", { bubbles: true });
		this.picker.options.element.dispatchEvent(evt);
	}

	getDate() {
		let isLevFormat = this.picker.options?.isLevFormat || false;
		const value = this.picker.options.date;
		if (value) {
			const parsedDate = Date.parse(value);
			let format = this.picker.options.format;

			this.picker.options.element.value = this.picker.options.element.getAttribute('value');

			setTimeout(() => {
				delete this.picker.getDate;
			}, 1);
			return new DateTime(parsedDate, format);
		}
		return this.picker.options.date || null;
	}
}


class CloseButtonPlugin extends BasePlugin {

	binds = {
		onView: this.onView.bind(this),
	}

	getName() {
		return 'CloseButtonPlugin';
	}

	onAttach() {
		this.picker.on('view', this.binds.onView);

		const stylesheet = document.createElement('style');
		stylesheet.innerText = `
			.container.close-button-plugin .calendars .calendar>.header .close-button {
				order: 5;
				font-size: 20px;
			}

			.container.close-button-plugin .calendars .calendar>.header .close-button:hover {
				color: var(--color-fg-primary);
			}
        `.replace(/\s\s+/g, '');
		this.picker.ui.shadowRoot.appendChild(stylesheet);
		this.stylesheet = stylesheet;
	}

	onView(event) {
		const {view, date} = event.detail;

		const header = this.picker.ui.container.querySelector('.header');

		if (header && !header?.querySelector('.close-button')){
			const button = document.createElement('button');
			button.classList.add('close-button', 'unit');
			button.innerHTML = "&times;";
			header.append(button);

			button.addEventListener('click', () => {
				const event = new PointerEvent('click', {});

				document.body.dispatchEvent(event)
			})
		}

		const resetButton = header?.querySelector('.reset-button');

		if (resetButton) {
			resetButton.addEventListener('click', () => {
				const birthdayInput = document.querySelector('#biirthday');
				if (birthdayInput) {
					birthdayInput.dispatchEvent(new Event('input', { bubbles: true }));
					birthdayInput.dispatchEvent(new Event('change', { bubbles: true }));
					birthdayInput.blur();

					birthdayInput.value = '';

					if (birthdayInput._flatpickr) {  // Example for Flatpickr
						birthdayInput._flatpickr.clear();
					}
				}
			});
		}
	  }
}

export {JewishCalendarPlugin, DatepickerPosition, LevcharityFormatter, CloseButtonPlugin};
